import httpClient from "@/common/service/HttpClient";
import { endPoints } from "@/constants/apiSetting";
const LocationService = {
    getLocationList(obj) {
        return httpClient.post(endPoints.getLocationList, obj);
    },
    getLocation(obj) {
        return httpClient.post(endPoints.getLocation, obj);
    },
    deleteLocation(obj) {
        return httpClient.post(endPoints.deleteLocation, obj);
    },
    updateLocation(obj) {
        return httpClient.post(endPoints.updateLocation, obj);
    },
    addLocation(obj) {
        return httpClient.post(endPoints.addLocation, obj);
    },
};

export default LocationService;



// WEBPACK FOOTER //
// ./src/service/LocationService.js